import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Button,
  Empty,
  Flex,
  Modal,
  Spin,
  Table,
  Tooltip,
  Typography,
  message,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import useApi from "../../utils/useApi";
import CreateCameras from "./CreateCameras";

const { Text } = Typography;

export default function ListCameras({ update, setUpdate }) {
  const [messageApi, contextHolder] = message.useMessage();
  const [modal, contextModal] = Modal.useModal();

  const [camerasList, setCamerasList] = useState([]);
  const [isCamerasLoading, setIsCamerasLoading] = useState(true);

  const [cameraToEdit, setCameraToEdit] = useState({});
  const [getInfos, setGetInfos] = useState(false);
  const [confirmEdition, setConfirmEdition] = useState(false);

  const { getCameras, removeCamera } = useApi();

  const loadData = useCallback(async () => {
    setIsCamerasLoading(true);
    try {
      const response = await getCameras();
      if (response?.data?.length) {
        const cameras = response.data.map((camera) => ({
          key: camera.id,
          name: camera.name || "",
          address: camera.address || "",
          image: camera.image || "",
        }));
        setCamerasList(cameras);
      } else {
        setCamerasList([]);
      }
    } catch (error) {
      console.error("Erro ao carregar câmeras:", error);
      setCamerasList([]);
    } finally {
      setIsCamerasLoading(false);
      if (update) {
        setUpdate(false);
      }
    }
  }, [getCameras, setUpdate, update]);

  useEffect(() => {
    if (update || !camerasList.length) {
      loadData();
    }
  }, [update, loadData, camerasList.length]);

  const handleRemoveCamera = useCallback(
    (id) => {
      removeCamera(id).then(() => {
        messageApi.success("Câmera removida com sucesso!");
        setUpdate(true);
      });
    },
    [removeCamera, messageApi, setUpdate]
  );

  const confirmDelete = useCallback(
    (id) => {
      modal.confirm({
        title: "Tem certeza que deseja remover essa câmera?",
        content: "Essa ação afetará as detecções imeadiatamente",
        onOk: () => handleRemoveCamera(id),
      });
    },
    [modal, handleRemoveCamera]
  );

  const handleCloseModal = useCallback(() => {
    setConfirmEdition(false);
    setCameraToEdit({});
  }, []);

  const collumns = [
    {
      title: "Título",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Endereço",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <Text>{text}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Editar",
      dataIndex: "edit",
      key: "edit",
      render: (text, record) => (
        <Button
          onClick={() => {
            setCameraToEdit(record);
            setGetInfos(true);
          }}
          icon={<EditOutlined />}
        />
      ),
    },
    {
      title: "Remover",
      dataIndex: "remove",
      key: "remove",
      render: (text, record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => confirmDelete(record.key)}
        />
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      {contextModal}

      {isCamerasLoading ? (
        <Flex justify="center" align="center">
          <Spin />
        </Flex>
      ) : camerasList.length > 0 ? (
        <>
          <Table columns={collumns} dataSource={camerasList} />
          <Modal
            title="Edite as informações necessárias"
            centered
            open={!!Object.keys(cameraToEdit).length}
            onOk={() => setConfirmEdition(true)}
            onCancel={handleCloseModal}
            width="50%"
            maskClosable={false}>
            <CreateCameras
              setUpdate={setUpdate}
              editMode
              getInfos={getInfos}
              setGetInfos={setGetInfos}
              cameraInfos={cameraToEdit}
              confirmEdition={confirmEdition}
              setConfirmEdition={setConfirmEdition}
              setCameraToEdit={setCameraToEdit}
              messageApi={messageApi}
            />
          </Modal>
        </>
      ) : (
        <Empty description="Nenhuma câmera cadastrada" />
      )}
    </>
  );
}
